import { page } from "../page-copy";

/** Weight stacks + KB punchline — React runtime pile vs lean compile-ahead. */
export default function CostFigure() {
  const { left, right } = page.costFigure;

  return (
    <div
      className="cost story-figure"
      role="img"
      aria-label={`${left.name} ${left.kb} KB versus ${right.name} ${right.kb} KB`}
    >
      <div className="cost-field">
        <div className="cost-side cost-side--heavy">
          <p className="cost-name">{left.name}</p>
          <span className="cost-arrow" aria-hidden="true">
            ↓
          </span>
          <div className="cost-stack cost-stack--heavy">
            <div className="cost-block" style={{ ["--i" as any]: 0 }}>
              {left.layers[0]}
            </div>
            <div className="cost-block" style={{ ["--i" as any]: 1 }}>
              {left.layers[1]}
            </div>
            <div className="cost-block" style={{ ["--i" as any]: 2 }}>
              {left.layers[2]}
            </div>
            <div className="cost-block cost-block--crush" style={{ ["--i" as any]: 3 }}>
              {left.layers[3]}
            </div>
          </div>
          <p className="cost-size">
            <span className="cost-num">{left.kb}</span>
            <span className="cost-unit">KB</span>
          </p>
        </div>

        <div className="cost-vs" aria-hidden="true">
          vs
        </div>

        <div className="cost-side cost-side--lean">
          <p className="cost-name">{right.name}</p>
          <span className="cost-arrow" aria-hidden="true">
            ↓
          </span>
          <div className="cost-stack cost-stack--light">
            <div className="cost-slim">
              <span className="cost-slim-scan" />
              <span className="cost-slim-text">{right.layers[0]}</span>
            </div>
            <div className="cost-slim cost-slim--out">
              <span className="cost-slim-text">{right.layers[1]}</span>
            </div>
          </div>
          <p className="cost-size">
            <span className="cost-num">{right.kb}</span>
            <span className="cost-unit">KB</span>
          </p>
        </div>
      </div>
    </div>
  );
}
